import type React from "react";

/** Combina múltiplas React refs em uma única ref callback. */
export const mergeRefs = <T = HTMLElement>(
  ...refs: Array<React.Ref<T> | null | undefined>
) => {
  const filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 1) return filteredRefs[0];
  return (inst: T | null) => {
    for (const ref of filteredRefs)
      if (typeof ref === "function") {
        (ref as (instance: T | null) => void)(inst);
      } else if (ref) {
        (ref as React.MutableRefObject<T | null>).current = inst;
      }
  };
};
